<div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 2%;">
        <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true"> Print </button>
        <button type="button" mat-raised-button matTooltip="Download Excel sheet" class="btn btn-danger"
            (click)="exportExcel('trial-balance-briefly')" style="margin-right: 10px;">
            Export
        </button>
        <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <!-- Header Section -->
            <div class="row rowborder hc px-5">
                <div class="common">
                    <span>दिनांक : {{ getFormattedDate() }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>पृष्ठ क्र : 1</span>
                </div>
                <div class="common text-center">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>ऊप खात्यांचा ट्रायल बॅलन्स मुख्य खाते - {{ exp_name }}</span>
                </div>
                <div class="common text-right">
                    <span>दिनांक पासून : {{ startDate | date: 'dd-MM-yyyy' }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>दिनांक पर्यंत : {{ endDate | date: 'dd-MM-yyyy' }}</span>
                </div>
            </div>
            <!-- Table Header -->
            <div class="row rowborder px-5">
                <div class="col-6"><span class="fw_600">तपशील</span></div>
                <div class="col-2" style="text-align: right;"><span class="fw_600">डेबिट</span></div>
                <div class="col-2" style="text-align: right;"><span class="fw_600">क्रेडिट</span></div>
            </div>
            <!-- Partitioned Report -->
            <div *ngFor="let category of categories">
                <div class="row rowborder hc px-5">
                    <div class="common text-left">
                        <button type="button" class="toggle-btn" (click)="toggleCategory(category)">
                            <mat-icon>{{ category.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                        <span class="ml-10">{{ category.name }}</span>
                    </div>
                </div>
                <div *ngIf="category.expanded && category.expenses?.length > 0">
                    <ng-container *ngFor="let group of category.expenses">
                        <div *ngIf="group.total_final_amt && group.total_final_amt !== 0">
                            <div class="row px-5">
                                <div class="col-6 fw_600">{{ group.exp_name }}</div>
                                <div class="col-2"></div>
                                <div class="col-2" style="text-align: right;">
                                    <span
                                        *ngIf="group.expenses?.length && ((group.expenses[0].exp_type === 'Expenditure' || group.expenses[0].exp_type === 'Assent') && group.total_final_amt < 0) || ((group.expenses[0].exp_type === 'Liabilities' || group.expenses[0].exp_type === 'Income') && group.total_final_amt < 0)">
                                        {{ (group.total_final_amt * -1).toFixed(2) }} </span>
                                </div>
                                <div class="col-2" style="text-align: right;">
                                    <span
                                        *ngIf="group.expenses?.length && ((group.expenses[0].exp_type === 'Liabilities' || group.expenses[0].exp_type === 'Income') && group.total_final_amt > 0) || ((group.expenses[0].exp_type === 'Expenditure' || group.expenses[0].exp_type === 'Assent') && group.total_final_amt > 0)">
                                        {{ (group.total_final_amt).toFixed(2) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="category.expanded && category.expenses?.length === 0">
                    <div class="row">
                        <div class="col-12 text-center">
                            <span>Data is Loading... for {{ category.name }}.</span>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- Total Section -->
            <div class="row rowborder">
                <div class="col-6 text-center fw_600">एकूण :</div>
                <div class="col-2"></div>
                <div class="col-2">
                    <span class="fw_600 text-right" style="margin-left: 20px !important"> {{ (getDebitTotal() < 0 ?
                            -getDebitTotal() : getDebitTotal()).toFixed(2) }} </span>
                </div>
                <div class="col-2">
                    <span class="fw_600 text-right" style="margin-left: 20px !important">{{ getCreditTotal().toFixed(2)
                        }}</span>
                </div>
            </div>

            <!-- 🧮 Difference Row -->
            <div class="row rowborder">
                <div class="col-6 text-center fw_600">फरक (Difference):</div>
                <div class="col-2"></div>
                <div class="col-2 text-right fw_600" style="padding-right: 85px;">
                    {{ getDifference() | number:'1.2-2' }}
                </div>
                <div class="col-2"></div>
            </div>

        </div>
    </div>